<template>
  <div>
    <div class="modal fade" id="addArticleModal" ref="modalEle" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Dodaj artykuł</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="px-3 pt-3">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <button class="nav-link"
                        :class="{ active: activeTab === 1 }"
                        @click.prevent="activeTab = 1">
                  Dane produktu
                </button>
              </li>
              <li class="nav-item">
                <button class="nav-link"
                        :class="{ active: activeTab === 2 }"
                        @click.prevent="activeTab = 2">
                  Pozostałe dane
                </button>
              </li>
            </ul>
          </div>

          <div class="modal-body">
            <!-- TAB 1 -->
		    <div v-show="activeTab === 1" class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Nr katalogowy</label>
                <input v-model="catalog_number"
                       class="form-control form-control-sm"
                       :class="{ 'is-invalid': errors.catalog_number }" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Model</label>
                <input v-model="model" class="form-control form-control-sm"  :class="{ 'is-invalid': errors.model }"/>
              </div>
              <div class="col-md-4">
                <label class="form-label">Jednostka</label>
				<select v-model="article_unit_id"
						class="form-select form-select-sm"
						:class="{ 'is-invalid': errors.article_unit_id }">
				  <option v-for="u in units" :key="u.id" :value="u.id">
					{{ u.name }}
				  </option>
				</select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Nazwa / opis</label>
                <input v-model="description"
                       class="form-control form-control-sm"
                       :class="{ 'is-invalid': errors.description }" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Szczegóły</label>
                <input v-model="details" class="form-control form-control-sm" />
              </div>

              <div class="col-md-6">
                <label class="form-label">Link</label>
                <input v-model="link" class="form-control form-control-sm" />
              </div>

              <div class="col-md-6">
                <label class="form-label">Lokalizacja</label>
                <input v-model="location" class="form-control form-control-sm" />
              </div>
            </div>

            <!-- TAB 2 -->
            <div v-show="activeTab === 2" class="row g-3">

			  <div class="col-md-4 position-relative">
			    <label class="form-label">Producent</label>
				<input v-model="producerSearch" @input="searchProducers" class="form-control form-control-sm" autocomplete="off"/>
				<ul v-if="producerResults.length" class="list-group position-absolute w-100 z-3">
				  <li v-for="p in producerResults" :key="p.id" class="list-group-item list-group-item-action" @click="selectProducer(p)">{{ p.name }}</li>
				</ul>
			  </div>

              <div class="col-md-4">
                <label class="form-label">Kategoria</label>
                <select v-model="category_id" class="form-select form-select-sm">
                  <option v-for="c in categories" :key="c.id" :value="c.id">
                    {{ c.name }}
                  </option>
                </select>
              </div>

<div class="col-md-4 position-relative">
  <label class="form-label">Dostawcy</label>

  <input
    v-model="supplierSearch"
    class="form-control form-control-sm"
    placeholder="Szukaj dostawcy..."
  />

  <div class="border rounded mt-1 p-2" style="max-height: 200px; overflow-y:auto;">
    
    <div v-for="s in filteredSuppliers" :key="s.id" class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        :id="'sup-' + s.id"
        :value="s.short_name"
        v-model="suppliers_array"
      />
      <label class="form-check-label" :for="'sup-' + s.id">
        {{ s.short_name }}
      </label>
    </div>

  </div>
</div>

              <div class="row g-3">

                <div class="col-md-3">
                  <label class="form-label">VAT</label>
                  <input v-model="vat" @input="onVatChange" type="number" class="form-control form-control-sm"/>
                </div>

                <div class="col-md-3">
                  <label class="form-label">Netto PLN</label>
                  <input v-model="price_netto_zl" @input="onNettoZlChange" type="number" class="form-control form-control-sm"/>
                </div>

                <div class="col-md-3">
                  <label class="form-label">Brutto PLN</label>
                  <input v-model="price_brutto_zl" @input="onBruttoZlChange" type="number" class="form-control form-control-sm"/>
                </div>

                <div class="col-md-3">
                  <label class="form-label">Netto EUR</label>
                  <input v-model="price_netto_eur" @input="onNettoEurChange" type="number" class="form-control form-control-sm"/>
                </div>

                <div class="col-md-3">
                  <label class="form-label">Brutto EUR</label>
                  <input v-model="price_brutto_eur" @input="onBruttoEurChange" type="number" class="form-control form-control-sm"/>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" @click="resetForm">Zamknij</button>
            <button type="button" class="btn btn-primary" @click="submit">Zapisz artykuł</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  props: {
    units: { type: Array, default: () => [] },
    producers: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
    suppliers: Array
  },
data() {
  return {
    modalObj: null,
    activeTab: 1,
    catalog_number: '',
    model: '',
    description: '',
    details: '',
    link: '',
    location: '',
    article_unit_id: null,
    producer_id: null,
    category_id: null,
    suppliers_short_names: '',
    vat: 23,
    price_netto_zl: 0,
    price_brutto_zl: 0,
    price_netto_eur: 0,
    price_brutto_eur: 0,
    errors: {},
	producerSearch: '',
producerResults: [],
supplierSearch: '',
suppliers_array: [],
  };
},
computed: {
filteredSuppliers() {
  if (!this.supplierSearch) return this.suppliers;

  return this.suppliers.filter(s =>
    s.short_name.toLowerCase().includes(this.supplierSearch.toLowerCase())
  );
}
},
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.modalEle;
      if (el) this.modalObj = new Modal(el);
    });

  },
watch: {
  units: {
    immediate: true,
    handler(val) {
      console.log('units:', val);
    }
  }
},
  methods: {
  searchProducers() {
  const value = this.producerSearch;

  if (value.length < 1) {
    this.producerResults = [];
    return;
  }

  this.producerResults = this.producers.filter(p =>
    p.name.toLowerCase().includes(value.toLowerCase())
  );
},
selectProducer(producer) {
  this.producer_id = producer.id;
  this.producerSearch = producer.name;
  this.producerResults = [];
},

setDataFromClone(article) {
  if (!article) return;

  this.catalog_number = article.catalog_number ?? this.catalog_number ?? '';
  this.model = article.model ?? '';
  this.description = article.description ?? '';
  this.details = article.details ?? '';
  this.link = article.link ?? '';
  this.location = article.location ?? '';

  this.article_unit_id = article.unit_id ?? null;

  this.producer_id = article.producer_id ?? null;
  this.category_id = article.category_id ?? null;

  if (!article.suppliers) {
    this.suppliers_array = [];
  } 
  else if (Array.isArray(article.suppliers)) {
    this.suppliers_array = article.suppliers.map(s => {
      if (typeof s === 'string') return s;
      if (typeof s === 'object') return s.short_name;
      return s;
    });
  } 
  else if (typeof article.suppliers === 'string') {
    this.suppliers_array = article.suppliers.split(',');
  } 
  else {
    this.suppliers_array = [];
  }

  this.vat = article.vat ?? 23;

  this.price_netto_zl = article.price_netto_zl ?? 0;
  this.price_brutto_zl = article.price_brutto_zl ?? 0;
  this.price_netto_eur = article.price_netto_eur ?? 0;
  this.price_brutto_eur = article.price_brutto_eur ?? 0;
},
  calcBrutto(netto, vat) {
    netto = parseFloat(netto) || 0
    vat = parseFloat(vat) || 0
    return +(netto * (1 + vat / 100)).toFixed(2)
  },

  calcNetto(brutto, vat) {
    brutto = parseFloat(brutto) || 0
    vat = parseFloat(vat) || 0
    return +(brutto / (1 + vat / 100)).toFixed(2)
  },

  onNettoZlChange() {
    this.price_brutto_zl = this.calcBrutto(this.price_netto_zl, this.vat)
  },

  onBruttoZlChange() {
    this.price_netto_zl = this.calcNetto(this.price_brutto_zl, this.vat)
  },

  onNettoEurChange() {
    this.price_brutto_eur = this.calcBrutto(this.price_netto_eur, this.vat)
  },

  onBruttoEurChange() {
    this.price_netto_eur = this.calcNetto(this.price_brutto_eur, this.vat)
  },

  onVatChange() {
    this.price_brutto_zl = this.calcBrutto(this.price_netto_zl, this.vat)
    this.price_brutto_eur = this.calcBrutto(this.price_netto_eur, this.vat)
  },
  
  validate() {
      this.errors = {};

      if (!this.catalog_number) this.errors.catalog_number = true;
      if (!this.model) this.errors.model = true;
      if (!this.description) this.errors.description = true;
      if (!this.article_unit_id) this.errors.article_unit_id = true;

      return Object.keys(this.errors).length === 0;
    },
	
  async submit() {
	  if (!this.validate()) {
		this.activeTab = 1;
		return;
	  }
	  const payload = {
		catalog_number: this.catalog_number,
		model: this.model,
		description: this.description,
		details: this.details,
		link: this.link,
		location: this.location,
		unit_id: this.article_unit_id,
		producer_id: this.producer_id,
		producer_name: this.producerSearch,
		category_id: this.category_id,
		suppliers: this.suppliers_array.join(','),
		vat: this.vat,
		price_netto_zl: this.price_netto_zl,
		price_brutto_zl: this.price_brutto_zl,
		price_netto_eur: this.price_netto_eur,
		price_brutto_eur: this.price_brutto_eur,
	  };

	  this.$emit('save-article', payload);
	    this.hide();
  this.resetForm();
  },
  
  show() {
      this.activeTab = 1;
      if (this.modalObj) this.modalObj.show();
    },
    hide() {
      if (this.modalObj) this.modalObj.hide();
    },
	resetForm() {
	  this.activeTab = 1;
	  this.errors = {};
	  this.catalog_number = '';
	  this.model = '';
	  this.description = '';
	  this.details = '';
	  this.link = '';
	  this.location = '';
	  this.article_unit_id = null;
	  this.producer_id = null;
	  this.producer_name = '';
	  this.producerSearch = '';
	  this.producerResults = [];
	  this.category_id = null;
	  this.suppliers_array = [];
	  this.vat = 23;
	  this.price_netto_zl = 0;
	  this.price_brutto_zl = 0;
	  this.price_netto_eur = 0;
	  this.price_brutto_eur = 0;
	}
  }
};
</script>
<style>
.position-absolute {
  background: white;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
}
</style>